/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import { ToFromDateRange } from '@/components/nav/title-bar';

type Props = {
  selectedPreset: string | null | undefined;
  toFromDateRange: ToFromDateRange;
};

export const useDaysConversion = (
  selectedPreset: Props['selectedPreset'],
  toFromDateRange: Props['toFromDateRange'],
  startParam?: string,
  endParam?: string,
  daysParam?: string | null
): string | undefined => {
  // If URL has days=all, return 'All Time' for the default observation window preset
  if (daysParam === 'all') return 'All Time';
  // If URL has start and end, calculate total number of days b/w them
  if (startParam && endParam) {
    const diffDays = Math.ceil(
      Math.abs(new Date(endParam).getTime() - new Date(startParam).getTime()) /
        (1000 * 60 * 60 * 24)
    );
    return `${diffDays} days`;
  }

  if (
    toFromDateRange?.from &&
    toFromDateRange?.to &&
    (!selectedPreset || selectedPreset === 'custom')
  ) {
    const diffTime = Math.abs(
      toFromDateRange.to.getTime() - toFromDateRange.from.getTime()
    );
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return `${diffDays} days`;
  }

  switch (selectedPreset) {
    case 'last5mins':
    case 'Last 5 minutes':
      return '5 minutes';
    case 'lastHour':
    case 'Last hour':
      return '1 hour';
    case 'last24hours':
    case 'Last 24 hours':
      return '24 hours';
    case 'last48hours':
    case 'Last 48 hours':
      return '48 hours';
    case 'last7':
    case 'Last 7 days':
      return '7 days';
    case 'last14':
    case 'Last 14 days':
      return '14 days';
    case 'last30':
    case 'Last one month':
      return '30 days';
    case 'allTime':
    case 'tillLastDiscovered':
      return 'All Time';
    default:
      return undefined;
  }
};
